'use client';

import { memo, useCallback, useEffect, useState } from 'react';

import { Modal } from '@bytel/trilogy-react-ts';

import { CartModal } from '@components/modal/cart-modal';
import { SSIBlock } from '@components/ssi-block';

import { useCartHeader } from '@hooks/use-cart-header';

function HeaderComponent() {
    const { hasItems, itemsCount } = useCartHeader();
    const [shouldShowModal, setShouldShowModal] = useState(false);
    const [cartModalTitle, setCartModalTitle] = useState('Votre panier est vide');

    // Mémorisation des callbacks pour éviter les re-renders inutiles
    const openModalCart = useCallback(() => setShouldShowModal(true), []);
    const closeModalCart = useCallback(() => setShouldShowModal(false), []);

    useEffect(() => {
        setCartModalTitle(hasItems ? 'Détails du panier' : 'Votre panier est vide');
    }, [hasItems]);

    useEffect(() => {
        document.addEventListener('action:panier:click', openModalCart);
        return () => {
            document.removeEventListener('action:panier:click', openModalCart);
        };
    }, [openModalCart]);

    useEffect(() => {
        setTimeout(() => {
            window.postMessage({ shopPanier: { badge: itemsCount.toString() } });
        }, 100);
    }, [itemsCount]);

    return (
        <>
            <SSIBlock tagId='header' url='/partials/v3/header/shop' />
            <Modal title={cartModalTitle} active={shouldShowModal} onClose={closeModalCart}>
                <CartModal onClose={closeModalCart} />
            </Modal>
        </>
    );
}

// Optimisation avec React.memo() - le composant ne se re-rendra que si ses props changent
// Comme ce composant n'a pas de props, il ne se re-rendra que quand le hook useCartHeader change
export const Header = memo(HeaderComponent);
